import { BoxGeometry, Mesh, ShaderMaterial, SphereGeometry } from "three";
import glslify from 'glslify';
import { MyShaderMat } from "./MyShaderMat";
import { Params } from "../data/Params";

export class MyColors{

    static colors:{r:number,g:number,b:number}[];

    public static init(){

        this.colors = [];
        let id = Params.colorId;

        console.log(id);

        for(let i=0;i<3;i++){

            switch(id){
                case 0:
                    this.colors[i]={
                        r: 0.99*Params.random(), 
                        g: 0.66*Params.random(),
                        b: 0.33*Params.random()
                    };
                    break;
                case 1:
                    this.colors[i]={
                        r: 0.66*Params.random(), 
                        g: 0.33*Params.random(),
                        b: 0.99*Params.random()
                    };
                    break;
                case 2:
                    this.colors[i]={
                        r: 0.33*Params.random(), 
                        g: 0.99*Params.random(),
                        b: 0.66*Params.random()
                    };    
                    break;
                case 3:
                    this.colors[i]={
                        r: 0.4+0.44*Params.random(), 
                        g: 0.4+0.44*Params.random(),
                        b: 0.6+0.33*Params.random()
                    };    
                    break;       
                case 4:
                    this.colors[i]={
                        r: 0.7+0.3*Params.random(), 
                        g: 0.7+0.3*Params.random(),
                        b: 0.99*Params.random()
                    };    
                    break;       
    
            }

        }

        console.log(this.colors);

    }

    public static getColor():{r:number,g:number,b:number}{

        return this.colors[
            Math.floor(Params.random()*this.colors.length)
        ];

    }


}